export class AutoSendToBookkeeperSettings {
	SendSales:boolean = false;
	SendPurchases:boolean = false;
	SendIncommingPeppolOrders:boolean = false;
	SendIncommingPeppolOrdersFromDate:Date | null = null;

	public constructor(data?:any) {
		if (!data) return;
		this.SendSales = data.SendSales;
		this.SendPurchases = data.SendPurchases;
		this.SendIncommingPeppolOrders = data.SendIncommingPeppolOrders;
		if (data.SendIncommingPeppolOrdersFromDate) {
			this.SendIncommingPeppolOrdersFromDate = new Date(data.SendIncommingPeppolOrdersFromDate);
		}
	}
}